/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */
function fn_parts_navigation_scroll_resize(){
	var heroHeight;
	if ($( '.navigation' ).length){
		if ($(window).scrollTop() > 1) {
			$( '.navigation' ).addClass( 'navigation-scroll' );
		} else {
			$( '.navigation' ).removeClass( 'navigation-scroll' );
		}
	} 

	if ($( '.navigation' ).length && $(window).width() < bp_medium && $( '.page-index' ).length) {
		heroHeight = $( '.hero-point' ).innerHeight();
		if ($(window).scrollTop() > heroHeight) {
			$( '.navigation' ).addClass( 'navigation-scroll' );
		} else {
			$( '.navigation' ).removeClass( 'navigation-scroll' );
		}
	}

	if ($('#pagination-bar').length){
        var sectionTop = $('#section-8').offset().top;

        if ($(window).scrollTop() < sectionTop  - $(window).height()) {
            $('#pagination-bar').addClass( class_active );
        } else {
            $('#pagination-bar').removeClass( class_active );
        }
    }
}
